/* global yaCounter62434330 */
import scrollDepth from 'scroll-depth';
import vars from '../globals';

export const spentOnPage15sec = () => {
	clearTimeout($(window).data('timeout15Sec'));

	$(window).data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
};

export const virtualHit = (path) => {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	if (window.yaCounter62434330) {
		yaCounter62434330.hit(path);
	}
};

scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

$('.header__logo--porsche').on('click', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

$('.header__logo--rbc').on('click', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

$('.card__sidebar').on('click', (e) => {
	let name = $(e.currentTarget).closest('.card').find('.card__name').text();

	ga('send', 'event', 'main', 'composer click', name);
});

$('.card-popup__close').on('click', (e) => {
	let id = $(e.currentTarget).closest('.card-popup').data('card');
	let name = $(`.card--${id}`).find('.card__name').text();

	ga('send', 'event', 'main', 'composer popup close', name);
});

// TODO: После обновления функционала проигрывателя. Сменить логику нажатия на триггер.
$('.product-text__selector').on('click', (e) => {
	let name = $(e.currentTarget).text();

	ga('send', 'event', 'audio', 'play', `article - ${name}`);
});

$('.share__button').on('click', (e) => {
	let page = vars.$html.data('page');

	let name = $(e.currentTarget).data('social');

	if (page === 'home') {
		ga('send', 'event', 'share', 'project share', name);
	} else if (page === 'product') {
		ga('send', 'event', 'share', 'article share', name);
	}
});

$('.product-composition__image').on('click', () => {
	ga('send', 'event', 'article', 'go to composition');
});

$('.home-cards__product').on('click', (e) => {
	let name = $(e.currentTarget).data('name');

	ga('send', 'event', 'banner', 'click', name, {nonInteraction: true});
});

let set30sInterval;

let initInterval30s = (name) => {
	set30sInterval = setInterval(() => {
		ga('send', 'event', 'audio', 'timing 30s', name);
	}, 30000);
};

vars.$document
	.on('card-audio-play', (e, name) => {
		ga('send', 'event', 'audio', 'play', `main composer - ${name}`);
		initInterval30s(name);
	})
	.on('card-audio-stop', () => {
		clearInterval(set30sInterval);
	})
	.on('card-audio-end', (e, name) => {
		ga('send', 'event', 'audio', 'finnish', name);
	})
	.on('card-audio-mute', (e, name) => {
		ga('send', 'event', 'audio', 'sound off', `main composer - ${name}`);
	})
	.on('product-audio-play', () => {
		ga('send', 'event', 'article', 'listen button click');
	})
	.on('beatmaker-play', () => {
		ga('send', 'event', 'audio', 'play', 'beatmaker');
	})
	.on('beatmaker-stop', () => {
		ga('send', 'event', 'audio', 'finnish', 'beatmaker');
	})
	.on('beatmaker-30sec', () => {
		ga('send', 'event', 'audio', 'timing 30s', 'beatmaker');
	})
	.on('beatmaker-track-type', (e, name, type) => {
		ga('send', 'event', 'audio', `beatmaker track ${type}`, name);
	})
;

$(window).on('resize scroll', () => {
	let $banner = $('.home-cards__product');

	let bannerTop = $banner.offset().top;
	let bannerHeight = $banner.height();

	let scrollTop = window.pageYOffset;
	let scrollTopHeight = scrollTop + window.innerHeight;

	if (scrollTopHeight >= bannerTop && bannerTop + bannerHeight >= scrollTop && !$banner.hasClass('isShown')) {
		$banner.addClass('isShown');

		let name = $banner.data('name');

		ga('send', 'event', 'banner', 'show', name, {nonInteraction: true});
	}
});
